<div *ngFor="let item of formPorscheOwner!.get('owner')!['controls'] let id = index">
    <div class="row p-2">
        <div class="col-sm-12">
            <div>
                <form [formGroup]="formPorscheOwner" (ngSubmit)="getOwner()">
                    <div class="row p-2">
                        <h4>Formulário {{id+1}}</h4>
                        <div class="col-sm-6">
                            <div class="form-floating mb-3">
                              <input class="form-control ps-5" inputmode="numeric" [dropSpecialCharacters]="false" [formControl]="item.get('cpf')"
                              #cpfCustomer [attr.id]="id"
                               (keyup)="checkCustomerRegister($event, id)" (input)="checkCustomerRegister($event, id)"  mask="000.000.000-00" type="text" placeholder="CPF">
                                <label for="floatingInput">CPF</label>
                                <div *ngIf="item.controls['cpf']?.errors && submitted == true">
                                    <div *ngIf="item.controls['cpf']?.errors?.['required'] == true">
                                          <p class="text-danger">Insira um cpf</p>
                                    </div>
                                    <div *ngIf="item.controls['cpf']?.errors?.['invalidCpf'] == true">
                                          <p class="text-danger">Cpf tem que ser válido</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-sm-6">
                            <div class="form-floating mb-3">
                                <input type="text" [readonly]="item.get('name').value !== '' && item.get('id').value !== ''" required="true" required class="form-control" [formControl]="item.get('name')" id="floatingInput">
                                <label for="floatingInput">Nome</label>
                                <div *ngIf="item.controls['name']?.errors && submitted == true">
                                    <div *ngIf="item.controls['name']?.errors?.['required'] == true">
                                          <p class="text-danger">Insira um nome</p>
                                    </div>
                                    <div *ngIf="item.controls['name']?.errors?.['notFull'] == true">
                                          <p class="text-danger">Insira o nome completo</p>
                                    </div>
                                    <div *ngIf="item.controls['name']?.errors?.['minlength'] == true">
                                          <p class="text-danger">Insira o nome completo</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-sm-6">
                            <div class="form-floating mb-3">
                                <input type="email" [readonly]="item.get('email').value !== '' && item.get('id').value !== ''" required="true" required class="form-control" [formControl]="item.get('email')" id="floatingInput" >
                                <label for="floatingInput">Email</label>
                                <div *ngIf="item.controls['email']?.errors && submitted == true">
                                    <div *ngIf="item.controls['email']?.errors?.['required'] == true">
                                          <p class="text-danger">Insira um email</p>
                                    </div>
                                    <div *ngIf="item.controls['email']?.errors?.['invalid'] == true">
                                          <p class="text-danger">Insira um email válido</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-floating mb-3">
                                <input type="text" [readonly]="item.get('phone').value !== '' && item.get('id').value !== ''" required="true" required [dropSpecialCharacters]="false" mask="(00) 00000-0000" class="form-control" [formControl]="item.get('phone')" id="floatingInput">
                                <label for="floatingInput">Telefone</label>
                                <div *ngIf="item.controls['phone']?.errors && submitted == true">
                                    <div *ngIf="item.controls['phone']?.errors?.['required'] == true">
                                          <p class="text-danger">Insira um número de celular válido</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-6">
                            <div class="form-floating mb-3">
                                <input type="text" required="true" required class="form-control" [formControl]="item.get('additionalInformation').get('model')" id="floatingInput" placeholder="000.000.000-00">
                                <label for="floatingInput">Modelo Porsche</label>
                                <div *ngIf="item.get('additionalInformation').controls['model']?.errors && submitted == true">
                                    <div *ngIf="item.get('additionalInformation').controls['model']?.errors?.['required'] == true">
                                          <p class="text-danger">Insira o modelo</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-floating mb-3">
                                <input type="text" required class="form-control" [formControl]="item.get('additionalInformation').get('version')" id="floatingInput" placeholder="name@example.com">
                                <label for="floatingInput">Versão</label>
                                <div *ngIf="item.get('additionalInformation').controls['version']?.errors && submitted == true">
                                    <div *ngIf="item.get('additionalInformation').controls['version']?.errors?.['required'] == true">
                                          <p class="text-danger">Insira a versão</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-floating mb-3">
                                <input type="text" required class="form-control" [formControl]="item.get('additionalInformation').get('yearModel')" id="floatingInput" placeholder="Nome">
                                <label for="floatingInput">Ano/Modelo</label>
                                <div *ngIf="item.get('additionalInformation').controls['yearModel']?.errors && submitted == true">
                                    <div *ngIf="item.get('additionalInformation').controls['yearModel']?.errors?.['required'] == true">
                                          <p class="text-danger">Insira o ano/modelo</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-floating mb-3">
                              <input type="text" class="form-control" required [formControl]="item.get('additionalInformation').get('plate')" id="floatingInput" placeholder="(00) 00000-0000">
                              <label for="floatingInput">Placa do veículo</label>
                              <div *ngIf="item.get('additionalInformation').controls['plate']?.errors && submitted == true">
                                  <div *ngIf="item.get('additionalInformation').controls['plate']?.errors?.['required'] == true">
                                        <p class="text-danger">Insira a placa</p>
                                  </div>
                              </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-floating mb-3">
                              <select  class="form-control" required [formControl]="item.get('additionalInformation').get('sizeShirt')" id="floatingInput">
                                  <option value="">Tamanho da camisa</option>
                                  <option value="PP">PP</option>
                                  <option value="P">P</option>
                                  <option value="M">M</option>
                                  <option value="G">G</option>
                                  <option value="GG">GG</option>
                              </select>
                              <div *ngIf="item.get('additionalInformation').controls['sizeShirt']?.errors && submitted == true">
                                  <div *ngIf="item.get('additionalInformation').controls['sizeShirt']?.errors?.['required'] == true">
                                        <p class="text-danger">Escolha o tamanho da camisa</p>
                                  </div>
                              </div>
                            </div>
                        </div>

                        <div class="form-floating mb-3">
                          <input type="text" class="form-control" [formControl]="item.get('additionalInformation').get('question')" id="floatingInput" placeholder="(00) 00000-0000">
                          <label for="floatingInput">Como ficou sabendo do Sportscar Together Day 2022?</label>
                        </div>

                    </div>

                    <button *ngIf="tickets.length -1 == id" class="btn btn-grad">Finalizar compra</button>
                </form>
            </div>
        </div>
    </div>
</div>
